import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class DeliveriesDeliveryAreaGatingModal extends Component {
  @service abilities;
  @service router;
  @service state;
  @service store;

  @tracked closed = false;

  get activeDeliveryAreas() {
    return this.store.peekAll('delivery-area').filter((area) => area.enabled);
  }

  get subscription() {
    return this.state.deliveriesSubscription;
  }

  get isCompliant() {
    if (!this.subscription) return true;
    return this.activeDeliveryAreas.length <= this.subscription.quantity;
  }

  get excessCount() {
    return Math.max(0, this.activeDeliveryAreas.length - (this.subscription?.quantity ?? 0));
  }

  get shouldDisplay() {
    return this.subscription && !this.closed;
  }

  get contentComponent() {
    if (this.abilities.can('disable delivery-area')) {
      return 'deliveries/delivery-area-gating-modal/billing-admin';
    }
    return 'deliveries/delivery-area-gating-modal/non-billing-admin';
  }

  @action
  close() {
    this.closed = true;
  }

  @action
  onClose() {
    // Hard gate — no soft dismiss. Redirect the user away from deliveries.
    this.closed = true;
    this.router.transitionTo('protected');
  }
}
